import { render, staticRenderFns } from "./PDAConfig.vue?vue&type=template&id=5c16e16e&scoped=true&"
import script from "./PDAConfig.vue?vue&type=script&lang=js&"
export * from "./PDAConfig.vue?vue&type=script&lang=js&"
import style0 from "./PDAConfig.vue?vue&type=style&index=0&id=5c16e16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16e16e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c16e16e')) {
      api.createRecord('5c16e16e', component.options)
    } else {
      api.reload('5c16e16e', component.options)
    }
    module.hot.accept("./PDAConfig.vue?vue&type=template&id=5c16e16e&scoped=true&", function () {
      api.rerender('5c16e16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/PDAConfig.vue"
export default component.exports